import indicators from '@shared/indicators/locales'
import financialInvestmentRiskLevelMessages from 'src/pages/PatrimonyDevelopment/FinancialInvestmentRiskLevel/FinancialInvestmentRiskLevelMessage/financial-investment-risk-level-message.locales'
import amountSelectionSection from 'src/tpbp-ds/components/ds-amount-selection/ds-amount-selection-section/ds-amount-selection-section.locales'
import graphPyramid from 'src/tpbp-ds/components/graph-pyramid/graph-pyramid.locales'
import comparisonSimulationCharts from 'src/tpbp-ds/components/indicators/charts/simulation/comparison-simulation-charts.locales'
import ownershipGridForm from 'src/tpbp-ds/components/ownership-grid-form/ownership-grid-form.locales'

export default {
  graphPyramid,
  indicators,
  comparisonSimulationCharts,
  financialInvestmentRiskLevelMessages,
  ds: {
    ownershipGridForm,
    amountSelectionSection
  }
}
